import { SearchX } from 'lucide-react';
import { ButtonLink } from '../components/Button';
import { EmptyState } from '../components/EmptyState';
import { PageBody } from '../components/PageBody';
import { PageHeader } from '../components/PageHeader';

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Nie ma takiej strony" />
      <PageBody>
        <EmptyState
          icon={SearchX}
          title="Ten adres nie prowadzi do żadnego ekranu"
          action={
            <ButtonLink to="/kalendarz" variant="secondary">
              Przejdź do kalendarza
            </ButtonLink>
          }
        />
      </PageBody>
    </>
  );
}
